import { NgModule } from '@angular/core';
import { EmptyWithToolbarComponent } from './empty-with-toolbar.component';
import { SharedModule } from '../../../shared';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserModule } from '../../common/user/user.module';
import { FooterModule } from '../../common/footer/footer.module';


@NgModule({
  declarations: [EmptyWithToolbarComponent],
  exports: [EmptyWithToolbarComponent],
  imports: [
    HttpClientModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    UserModule,
    SharedModule,
    FooterModule
  ]
})
export class EmptyWithToolbarModule {
}
